import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconThumbsUp: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="-5 0 36 36" name="thumbs-up">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.882.574a.833.833 0 0 0-1.432 0l-1.714 2.879-2.273 1.91a.833.833 0 0 0 0 1.275l2.273 1.91 1.714 2.879a.834.834 0 0 0 1.432 0l1.714-2.88 2.273-1.909a.833.833 0 0 0 0-1.276l-2.273-1.91L23.882.575Zm-1.786 3.853 1.07-1.797 1.07 1.797c.047.08.108.151.18.211L26.037 6l-1.621 1.362a.833.833 0 0 0-.18.212l-1.07 1.797-1.07-1.797a.834.834 0 0 0-.18-.212L20.295 6l1.621-1.362a.834.834 0 0 0 .18-.211Z"
    />
    <path d="M10.045 3.5A3.683 3.683 0 0 0 6.66 5.733l-3.827 8.929a.833.833 0 0 1-.766.505H.666v1.667h1.401a2.5 2.5 0 0 0 2.298-1.515l3.827-8.93a2.017 2.017 0 0 1 3.766 1.432l-1.351 4.055a2.5 2.5 0 0 0 2.371 3.291h7.042c.57 0 .97.557.79 1.097L16.923 27.93a.833.833 0 0 1-.79.57h-9.24a.833.833 0 0 1-.372-.088l-2.63-1.314a2.5 2.5 0 0 0-1.117-.264H.666V28.5h2.107c.129 0 .257.03.372.088l2.63 1.315a2.5 2.5 0 0 0 1.118.264h9.238a2.5 2.5 0 0 0 2.372-1.71l3.889-11.666a2.5 2.5 0 0 0-2.372-3.29h-7.042a.833.833 0 0 1-.79-1.098l1.351-4.055c.796-2.385-.98-4.848-3.494-4.848Z" />
  </Icon>
);
